export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    last_person:'',
    last_entry_record: [],
  },
  getters: {
    last_entry_record(state) {
      return state.last_entry_record
    },
    currentCenterId(state) {
      return state.id
    },
    currentCenterName(state) {
      return state.name
    },
    last_person(state) {
      return state.last_person
    },
  },
  mutations: {
    UPDATE_ENTRY_RECORD(state, val) {
      state.last_entry_record = val
    },
    UPDATE_CENTER_ID(state, val) {
      state.id = val
    },
    UPDATE_CENTER_NAME(state, val) {
      state.name = val
    },
    UPDATE_LAST_PERSON(state, val) {
      state.last_person = val
    },
  },
  actions: {},
}
